import type { FilterRuleModel } from '@/shared/components/filter/types'
import type { FilterSchema } from '@/shared/components/filter/validation'
import type { StopListSettingsModel } from '@/shared/generated'

import { Operators } from '@/shared/components/query-builder'

/**
 * Checks if rule is sku rule
 * @param rule -  FilterRuleModel
 * @returns - true if rule is sku rule
 */
export const isSkuRule = (rule: FilterSchema): boolean =>
	rule.name === 'sku' &&
	rule.operation === Operators.IS &&
	'value' in rule &&
	rule.value !== undefined
/**
 * Get only sku rules from settings
 * @param settings - StopListSettingsModel
 * @returns - FilterRuleModel[] with only sku rules
 */
export const getSkuRules = (
	settings: StopListSettingsModel
): FilterRuleModel[] => settings?.custom_rules?.filter(isSkuRule) ?? []
